export { LanguageProvider } from './LanguageProvider';

import { LanguageProvider } from './LanguageProvider';

export const __ = (msg: string): string => {
  const langJson = LanguageProvider.translations || {};
  return langJson[msg] || msg;
};

export const __r = (routes: string, defaultRoute: string): string => {
  const langJson = LanguageProvider.translations || {};
  return langJson[routes] && langJson[routes].indexOf('routes:') == -1
    ? langJson[routes]
    : defaultRoute;
};
